import { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
// @mui
import { styled } from "@mui/material/styles";
import { Box, Card, Stack, Link, Container, Typography } from "@mui/material";
// routes
import { PATH_AUTH } from "../../routes/paths";
// hooks
import useResponsive from "../../hooks/useResponsive";
// components
import Page from "../../components/Page";
import { getMaintenanceStatus } from "src/pages/api";
// sections
import { LoginForm } from "../../sections/auth/login";
import Logo from "../../assets/logo.png";
// ----------------------------------------------------------------------

const RootStyle = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  display: "flex",
  minHeight: "100vh",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Login() {
  const smUp = useResponsive("up", "sm");
  const [maintenanceMsg, setMaintenanceMsg] = useState("");
  const [isMaintenance, setIsMaintenance] = useState(false);

  useEffect(() => {
    const controller = new AbortController();

    const fetchMaintenanceStatus = async () => {
      try {
        const response = await getMaintenanceStatus({
          signal: controller.signal,
        });
        if (response?.data?.admin?.maintenance) {
          setIsMaintenance(true);
          setMaintenanceMsg(
            response?.data?.admin?.message || "We’re undergoing maintenance."
          );
        } else {
          setIsMaintenance(false);
        }
      } catch (error) {
        console.error("Maintenance check failed:", error);
      }
    };

    fetchMaintenanceStatus();

    return () => controller.abort();
  }, []);

  return (
    <Page title="Login">
      {/* Maintenance Banner */}
      {isMaintenance && (
        <Box
          sx={{
            bgcolor: "#ffea00",
            color: "#000",
            p: 1.5,
            animation: "slide-in 1.5s ease-out, shake 3s infinite alternate",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 2000,
            textAlign: "center",
            fontSize: "1.5rem",
            letterSpacing: "0.5px",
            textTransform: "uppercase",
            boxShadow: 3,
            "@keyframes slide-in": {
              from: { transform: "translateY(-100%)" },
              to: { transform: "translateY(0)" },
            },
            "@keyframes shake": {
              "0%": { transform: "translateX(0)" },
              "25%": { transform: "translateX(-2px)" },
              "50%": { transform: "translateX(2px)" },
              "75%": { transform: "translateX(-1px)" },
              "100%": { transform: "translateX(1px)" },
            },
          }}
        >
          <span
            style={{
              animation: "blinker 3s linear infinite",
              display: "inline-block",
            }}
          >
            🚧
          </span>{" "}
          {maintenanceMsg}
        </Box>
      )}
      <RootStyle>
        <Container maxWidth="sm">
          <ContentStyle>
            <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
              <Box sx={{ flexGrow: 1, textAlign: "center" }}>
                <img
                  src={Logo}
                  alt="logo"
                  style={{ width: 150, margin: "auto", marginBottom: 14 }}
                />
                <Typography variant="h4">
                  Sign in to Pupilkart Admin Portal
                </Typography>
                <Typography sx={{ color: "text.secondary" }}>
                  Enter your details below.
                </Typography>
              </Box>
            </Stack>

            {/* <Alert severity="info" sx={{ mb: 3 }}>
              Use email : <strong>demo@minimals.cc</strong> / password :<strong> demo1234</strong>
            </Alert> */}

            <LoginForm />

            {!smUp && (
              <Typography variant="body2" align="center" sx={{ mt: 3 }}>
                Don’t have an account?{" "}
                <Link
                  variant="subtitle2"
                  component={RouterLink}
                  to={PATH_AUTH.register}
                >
                  Get started
                </Link>
              </Typography>
            )}
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
